"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCall = function SvgCall(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#007AFF",
    d: "M2.477 1.312c-.468.415-.762.677-.881.785-.666.59-.774 1.425-.323 2.505.676 1.62 3.213 5.526 8.736 8.828 1.219.853 2.314.66 2.816 0 .336-.441.664-.864.986-1.267.358-.55.207-1.06-.451-1.532-.988-.706-.673-.457-1.48-1.008-.807-.551-.8-.428-1.87 0-1.071.428-1.082.8-2.142-.208A78.882 78.882 0 0 1 5.149 6.66c-.414-.388-.414-.872 0-1.451.622-.87.622-1.205 0-2.158a18.063 18.063 0 0 0-1.28-1.738c-.46-.416-.924-.416-1.392 0z"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCall);
var _default = exports["default"] = Memo;